import React, { useState, useEffect, useRef } from 'react';
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import { gsap } from 'gsap';

//Components
import Nav from './nav';
import NavLang from './nav-lang';

const Header = ({ lang }) => {
  const headerRef = useRef(null);
  const navHeaderRef = useRef(null);
  const [nav, setNav] = useState(false);

  const activateNav = () => {
    document
      .querySelectorAll('.nav-header .nav .nav__item-has-submenu')
      .forEach(item => item.classList.remove('active'));
    setNav(!nav);

    if (!nav) {
      gsap.to(navHeaderRef.current, {
        duration: 0.8,
        yPercent: 0,
        force3D: true,
        opacity: 1,
        ease: 'power4.out',
      });
    } else {
      gsap.to(navHeaderRef.current, {
        duration: 0.8,
        yPercent: 100,
        force3D: true,
        opacity: 0,
        ease: 'power4.out',
      });
    }
  };

  useEffect(() => {
    gsap.set(navHeaderRef.current, {
      yPercent: 100,
      opacity: 0,
      force3D: true,
    });

    gsap.to(headerRef.current, {
      duration: 0.8,
      delay: 0.65,
      ease: 'power0.easeNone',
      opacity: 1,
    });
  }, []);

  return (
    <header
      ref={headerRef}
      className={`header py-4 py-md-5 ${nav ? 'active-nav' : ''}`}
    >
      <div className="container">
        <div className="header__inner d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <AniLink
              cover
              direction="up"
              bg="#092431"
              className="logo"
              to={`/${lang}`}
            >
              <span className="logo__dark"></span>

              <span className="logo__light"></span>
            </AniLink>

            <div className="d-none d-md-block">
              <NavLang lang={lang} />
            </div>
          </div>

          <button
            className="nav-btn d-inline-flex align-items-center"
            onClick={activateNav}
          >
            <p className="font-weight-medium">MENU</p>

            <span className="nav-btn__inner ml-3">
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
      </div>

      <div ref={navHeaderRef} className="nav-header py-14 pr-9 pr-md-0">
        <div className="container">
          <Nav lang={lang} />

          <div className="header__contacts d-block d-md-inline-block pt-4 mt-3 pr-md-10">
            <p className="text-secondary text-right text-md-left mb-3">
              <i className="fal fa-phone-alt mr-4"></i>

              <a className="text-secondary" href="tel:0035929251366">
                +3592 925 13 66
              </a>
            </p>

            <p className="text-secondary text-right text-md-left">
              <i className="fal fa-envelope mr-4"></i>

              <a className="text-secondary" href="mailto:info@bgsteel.bg">
                info@bgsteel.bg
              </a>
            </p>
          </div>

          <div className="d-md-none mt-6">
            <NavLang lang={lang} />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
